"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var utils_exports = {};
__export(utils_exports, {
  announceSelection: () => announceSelection,
  computedId: () => computedId,
  defineScrollBehavior: () => defineScrollBehavior,
  filterItems: () => filterItems
});
module.exports = __toCommonJS(utils_exports);
var isScrollable = function isScrollable2(listBox) {
  return listBox && listBox.clientHeight < listBox.scrollHeight;
};
var maintainScrollVisibility = function maintainScrollVisibility2(activeOption, listBox) {
  var offsetHeight = activeOption.offsetHeight, offsetTop = activeOption.offsetTop;
  var parentOffsetHeight = listBox.offsetHeight, scrollTop = listBox.scrollTop;
  var isAbove = offsetTop < scrollTop;
  var isBelow = offsetTop + offsetHeight > scrollTop + parentOffsetHeight;
  if (isAbove) {
    listBox.scrollTo(0, offsetTop);
  } else if (isBelow) {
    listBox.scrollTo(0, offsetTop - parentOffsetHeight + offsetHeight);
  }
};
var isElementInView = function isElementInView2(activeOption) {
  var bounding = activeOption.getBoundingClientRect();
  return bounding.top >= 0 && bounding.left >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounding.right <= (window.innerWidth || document.documentElement.clientWidth);
};
var defineScrollBehavior = function defineScrollBehavior2(listBox, options, position) {
  if (isScrollable(listBox)) {
    maintainScrollVisibility(options[position], listBox);
  }
  if (!isElementInView(options[position])) {
    options[position].scrollIntoView({
      behavior: "smooth",
      block: "nearest"
    });
  }
};
var computedId = function computedId2(nodeName, id) {
  return "select-".concat(nodeName).concat(id ? "-".concat(id) : "");
};
var filterItems = function filterItems2(selected, value) {
  return selected.filter(function(item) {
    return item !== value && item !== "allOptions";
  });
};
var announceSelection = function announceSelection2(disabled, isSelected, ariaLabel, children, value) {
  if (typeof children !== "string" && !ariaLabel && !disabled) {
    if (!value)
      return void 0;
    var text = typeof value === "string" ? value.charAt(0).toUpperCase() + value.slice(1) : value;
    return isSelected ? "".concat(text, " selected") : "".concat(text, " not selected");
  }
  if (!disabled) {
    return isSelected ? "".concat(ariaLabel || children, " selected") : "".concat(ariaLabel || children, " not selected");
  }
  return ariaLabel ? "".concat(ariaLabel) : void 0;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  announceSelection,
  computedId,
  defineScrollBehavior,
  filterItems
});
//# sourceMappingURL=utils.js.map